// src/utils/download.js - save a file received through the API (blob responses).
import { getErrorMessage, toApiError } from '../services/api';

/** File name from a Content-Disposition header (RFC 5987 first, then the ASCII form). */
export function filenameFromHeaders(headers, fallback) {
  const cd = headers && (headers['content-disposition'] || headers['Content-Disposition']);
  if (cd) {
    const utf8 = cd.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8) {
      try {
        return decodeURIComponent(utf8[1]);
      } catch (e) {
        /* fall through */
      }
    }
    const ascii = cd.match(/filename="?([^";]+)"?/i);
    if (ascii) return ascii[1];
  }
  return fallback;
}

/** Offer `blob` as a download. The object URL is revoked later (Safari/iOS need it alive). */
export function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    link.remove();
    window.URL.revokeObjectURL(url);
  }, 1000);
}

/**
 * Czech message for a failed blob request. With responseType "blob" the JSON error
 * body arrives as a Blob, so it is read and parsed here.
 */
export async function blobErrorMessage(error, fallback) {
  const apiError = toApiError(error);
  const data = apiError.data;
  if (data && typeof data.text === 'function') {
    try {
      const body = JSON.parse(await data.text());
      if (body && (body.error || body.message)) return body.error || body.message;
    } catch (e) {
      /* not JSON */
    }
  }
  if (apiError.status === 404 && fallback) return fallback;
  return getErrorMessage(apiError, fallback);
}
